<script>
  import { fade } from 'svelte/transition';
  import { inertia, page } from '@inertiajs/svelte';

  let open = false;

  $: languages = $page.props.languages;

  $: currentLanguage = languages.find((language) => language.current_lang)[0];

  $: otherLanguages = languages.filter((language) => !language.current_lang);
</script>

<div class="lang-switch">
  {#if languages.length == 1}
    <p>{languages[0].name}</p>
  {:else if languages.length == 2}
    <a
      class="lang-switch__toggle"
      href={otherLanguages[0].url}
      hreflang={otherLanguages[0].locale}
    >{otherLanguages[0].name}</a
    >
  {:else}
    <button
      class="lang-switch__toggle"
      on:click={() => {
        open = !open;
      }}>{currentLanguage.name}</button
    >
    {#if open}
      <nav
        class="lang-switch__dropdown"
        aria-label="language switch"
        transition:fade
      >
        <ul>
          {#each otherLanguages as language}
            <li>
              <a href={language.name} hreflang={language.locale} use:inertia
                >{language.name}</a
              >
            </li>
          {/each}
        </ul>
      </nav>
    {/if}
  {/if}
</div>

<style lang="scss">
  .lang-switch {
    position: relative;
    color: rgb(var(--white));

    &:hover {
      @include gradient('blue', 135deg);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &__toggle {
      padding: 1rem 0;
      --white: 255, 255, 255, 0.2;
      border-bottom: 1px solid rgb(var(--white));
    }

    &__dropdown {
      position: absolute;
      z-index: 1;
      top: 100%;
      left: 0;
      right: 0;
    }
  }
</style>
